import { createRootRouteWithContext } from "@tanstack/react-router";
import BaseLayout from "../layout/BaseLayout.tsx";
import { getAccount } from "../api/AccountApi.ts";
import type { Account } from "../api/AccountSchema.ts";

export const Route = createRootRouteWithContext<{
  account: Account | undefined;
}>()({
  component: BaseLayout,
  beforeLoad: async ({ context }) => {
    context.account = await getAccount();
  },
});
